import AlertWarningAddressInvalidContainer from './alert-warning-address-invalid-container';

export default AlertWarningAddressInvalidContainer;
